// 読み上げ。PC版の onnx ローカルTTSではなく Web Speech API（OS内蔵音声）を使う。
// 声質・指定方法はOS依存（DECISIONS 2026-06-23 の合意どおり）。
export function ttsAvailable() {
  return typeof window !== 'undefined' && 'speechSynthesis' in window
}

function pickVoice(lang) {
  const vs = window.speechSynthesis.getVoices()
  if (!vs || !vs.length) return null
  return (
    vs.find((v) => /^en[-_]US/i.test(v.lang)) ||
    vs.find((v) => /^en/i.test(v.lang)) ||
    vs[0]
  )
}

export function speak(text, lang = 'en-US') {
  if (!ttsAvailable() || !text) return
  try {
    window.speechSynthesis.cancel()
    const u = new SpeechSynthesisUtterance(text)
    u.lang = lang
    const v = pickVoice(lang)
    if (v) u.voice = v
    u.rate = 0.95
    window.speechSynthesis.speak(u)
  } catch {
    /* noop */
  }
}
